<template>
    <div class="pa-3">
        <v-layout wrap v-if="error">
            <v-flex xs12>
                  <v-alert :value="true" color="error" icon="warning" outline>{{error}}</v-alert>
            </v-flex>
        </v-layout>
        <v-layout wrap class="action-buttons-container">
            <v-flex xs12 class="text-xs-center">
                <h3>Reject Punnets</h3>
            </v-flex>
            <v-flex xs12 sm6>
                  <v-text-field
                    box
                    v-model="search.barcode"
                    label="Barcode"
                    clearable>
                </v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
                <v-menu v-model="dateMenu" :close-on-content-click="true" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field box v-model="dateString" label="Date" readonly v-on="on" ></v-text-field>
                    </template>
                    <v-date-picker  v-model="search.date" ></v-date-picker>
                </v-menu>
            </v-flex>
            <v-flex xs12 sm4>
                 <v-autocomplete
                    box
                    :items="teams"
                    item-text="TeamName"
                    item-value="TeamID"
                    v-model="search.teamID"
                    label="Team"
                    clearable
                    :disabled="false"
                ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm4>
                <v-autocomplete
                    box
                    :items="locations"
                    item-text="LocationName"
                    item-value="LocationID"
                    v-model="search.locationID"
                    label="Location"
                    clearable
                    :disabled="false"
                ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm4>
                <v-autocomplete
                    box
                    :items="varieties"
                    item-text="VarietyName"
                    item-value="VarietyID"
                    v-model="search.varietyID"
                    label="Variety"
                    clearable
                    :disabled="false"
                ></v-autocomplete> 
            </v-flex>
            <v-flex xs12 sm4 md2 offset-md3>
                <v-btn block color="warning" :disabled="loading || exporting" @click="clearFilter()">Clear</v-btn>
            </v-flex>
            <v-flex xs12 sm4 md2>
                <v-btn block color="accent" :disabled="exporting" :loading="loading" @click="filter()">Filter</v-btn>
            </v-flex>
            <v-flex s12 sm4 md2>
                <v-btn block color="primary" :disabled="loading" :loading="exporting" @click="exportRejectedPunnets()">Export</v-btn>
            </v-flex>
                           
        </v-layout>
        <v-layout wrap class="action-buttons-container">
            <v-flex xs12 sm3 offset-sm3>
                <v-btn block color="error" :disabled="loading" @click="cancelChanges()">Cancel</v-btn>
            </v-flex>
            <v-flex xs12 sm3>
                <v-btn block color="primary" :disabled="loading" @click="confirmChanges()">Save</v-btn>
            </v-flex>
        </v-layout>

        <v-layout wrap>
            <v-flex xs12 class="text-xs-center">
                <h3>Session List</h3>
            </v-flex>
            <v-flex xs12>
                <v-data-table
                    :headers="headers" 
                    :items="sessions"
                    :pagination.sync="pagination"
                    :loading="loading"
                    no-data-text=""
                >
                    <template v-slot:progress>
                        <v-progress-linear color="primary" indeterminate></v-progress-linear>
                    </template>
                    <template v-slot:items="props">
                       <tr :key="props.item.SessionProductID">
                                <td>{{props.item.TeamName}}</td>
                                <td>{{props.item.LocationName}}</td>
                                <td>{{props.item.VarietyName}}</td>
                                <td>{{props.item.StartTime | formatDateTime}}</td>
                                <td>{{props.item.EndTime | formatDateTime}}</td>
                                <td>{{props.item.Quantity}}</td>
                                <td>{{props.item.Seconds}}</td>
                                <td>{{props.item.UnitName}}</td>
                               
                                <td> 
                                   <EditTableCell   
                                        :value="props.item.RejectedPunnets.toString()"
                                        @input="updateSessionRejectedPunnets(props.item, $event)"
                                        :rules="[]"
                                        >
                                    </EditTableCell>
                                </td>
                                <td>{{((props.item.NumberInTray == null || props.item.NumberInTray == 0) ? 0 :  Math.round((props.item.RejectedPunnets / props.item.NumberInTray) * 100) / 100) | thousandsSeparators}}</td>
                                <td>{{(Math.round(props.item.RejectedPunnets * props.item.AveKgsPerUnit * 100) / 100) | thousandsSeparators}}kg</td>
                                <td>{{props.item.SentToPayroll}}</td>
                            </tr>
                    </template>
                    <template v-slot:no-data v-if="!loading">
                        <v-alert :value="true" color="warning" icon="warning" outline>No available session found</v-alert>
                    </template>
                </v-data-table> 
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import EditTableCell from '@/components/rejections/EditTableCell.vue';

import moment from 'moment';

 
export default {
    props: ["plantID"],
    data() {
        return {
            loading: false,
            exporting: false,
            error: null,
            search: {
                barcode: "",
                date: new Date().toISOString().substr(0, 10),
                teamID: null,
                locationID: null,
                varietyID: null
            },
            pagination: {
                rowsPerPage: 25
            },
            dateMenu: false,
            headers: [
                {
                    text: "Team",
                    value: "TeamName",
                },
                {
                    text: "Location",
                    value: "LocationName",
                },
                {
                    text: "Variety",
                    value: "VarietyName",
                },
                {
                    text: "Start Time",
                    value: "StartTime",
                },
                {
                    text: "End Time",
                    value: "EndTime"
                },
                {
                    text: "Quantity",
                    value: "Quantity"
                },
                {
                    text: "Seconds Kgs",
                    value: "Seconds"
                },
                {
                    text: "Unit",
                    value: "UnitName"
                },
                {
                    text: "Rejected Punnets",
                    value: "RejectedPunnets"
                },
                {
                    text: "Rejected Trays",
                    value: "RejectedPunnets"
                },
                {
                    text: "Rejected Kgs",
                    value: "RejectedPunnets"
                },
                {
                    text: "Sent To Payroll",
                    values: "SentToPayroll"
                }
            ]
        } 
    },
    components: {
       EditTableCell
    },
    async created() {
        await this.filter();
    },
    computed: {
        ...mapState("RejectionStore", {
            teams: state => state.teams,
            locations: state => state.locations,
            varieties: state => state.varieties,
            sessions: state => state.sessions
        }),
        ...mapGetters({
        }),
        dateString() {
            return this.search.date == null ? "" :  moment(this.search.date).format("DD/MM/YYYY");
        }
    },
    methods: {
           ...mapActions("RejectionStore", [
            "loadSessions",
            "updateRejectedPunnets",
            "exportToCSV"
        ]),
        async filter() {
            try {
                this.loading = true;
                this.error = null;
                this.search.plantID = this.plantID;
                await this.loadSessions( this.search );
            } catch(e) {
                this.error = e.toString();
               
            } finally {
                this.loading = false;
            }
        },
        async exportRejectedPunnets() {
            try {
                this.exporting = true;
                this.error = null;
                this.search.plantID = this.plantID;
                await this.exportToCSV(this.search);
            } catch(e) {
                this.error = e.toString();
            } finally {
                this.exporting = false;
            }
        },
        async cancelChanges() {
            await this.filter();
        },
        async confirmChanges() {
            try {
                this.loading = true;
                this.error = null;
                await this.updateRejectedPunnets();
            } catch(e) {
                this.error = e.toString();
            } finally {
                this.loading = false;
            }
        },
        clearSearchDate() {
            this.plantingMenu = true;
            this.$set(this.search, 'date', null);
            this.dateMenu = false;
        },
        updateSessionRejectedPunnets(session, newValue) {
            session.RejectedPunnets = parseInt(newValue);
        },
        clearFilter() {
            this.search = {
                barcode: "",
                date: new Date().toISOString().substr(0, 10),
                teamID: null,
                locationID: null,
                varietyID: null
            };
        }

    }
}
</script>

<style>

</style>
